import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, Star, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-8 pb-12 lg:pt-12 lg:pb-16 overflow-hidden px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-63">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl" data-id="element-65">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-alt-bg text-brand-deep-green text-sm font-medium mb-6" data-id="element-66">
            <Sparkles size={16} data-id="element-67" />
            <span data-id="element-68">Mega Kit Tricotín Creativo</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.1] mb-6 text-brand-text" data-id="element-69">
            Domina el arte del tricotín y creá detalles hermosos que también
            podés{' '}
            <span className="text-brand-cta italic" data-id="element-70">vender desde casa</span>
          </h1>

          <p className="text-lg sm:text-xl text-brand-text/80 mb-4 leading-relaxed" data-id="element-71">
            Descubrí cómo hacer nombres, decoraciones y piezas especiales para
            regalar o emprender.
          </p>

          <Button onClick={scrollToPurchase} className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-72">
            QUIERO UN DESCUENTO
          </Button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative" data-id="element-73">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-brand-card aspect-[4/5] sm:aspect-square lg:aspect-[4/5] flex items-center justify-center p-4" data-id="element-74">
            <video src="https://cdn.magicpatterns.com/uploads/uPYJpwLKAXaf3f7QNZpAGV/WhatsApp Video 2026-03-29 at 23.21.09.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover rounded-2xl" data-id="element-75" />
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8
        }} className="absolute -bottom-6 left-4 right-4 sm:left-auto sm:right-auto sm:-bottom-8 sm:-left-8 bg-brand-card p-4 rounded-2xl shadow-xl flex flex-col gap-3 border border-brand-bg" data-id="element-76">
            <div className="flex items-center gap-2 text-sm font-medium text-brand-text" data-id="element-77">
              <Star className="text-brand-cta fill-brand-cta" size={16} data-id="element-78" />
              Ideal para principiantes
            </div>
            <div className="flex items-center gap-2 text-sm font-medium text-brand-text" data-id="element-79">
              <Download className="text-brand-accent" size={16} data-id="element-80" />
              Descarga inmediata
            </div>
            <div className="flex items-center gap-2 text-sm font-medium text-brand-text" data-id="element-81">
              <CheckCircle2 className="text-brand-deep-green" size={16} data-id="element-82" />
              Kit completo incluido
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}